module.exports = __webpack_public_path__ + "img/nt118-05-81-1.prt.de65ba62.jpg";